import { NgModule } from '@angular/core';
import { ButtonComponent } from '@rensa/shared/components/button/button.component';
import { InputComponent } from './components/input/input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { FaIconComponent, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CheckboxComponent } from '@rensa/shared/components/checkbox/checkbox.component';
import { TextAreaComponent } from '@rensa/shared/components/textarea/textarea.component';
import { SelectComponent } from './components/select/select.component';
import { DateTimeComponent } from './components/date-time/date-time.component';
import { Ng2FlatpickrModule } from 'ng2-flatpickr';
import { LabelComponent } from './components/label/label.component';
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { ModalComponent } from './components/modal/modal.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { SwitchComponent } from './components/switch/switch.component';

const inAndExports = [
  ButtonComponent,
  InputComponent,
  CheckboxComponent,
  SwitchComponent,
  TextAreaComponent,
  FeedbackComponent,
  SelectComponent,
  DateTimeComponent,
  LabelComponent,
  StripHtmlPipe,
  ModalComponent,
];

@NgModule({
  declarations: inAndExports,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    OverlayModule,
    FontAwesomeModule,
    Ng2FlatpickrModule,
  ],
  providers: [DatePipe],
  exports: [...inAndExports, ReactiveFormsModule, FaIconComponent, CommonModule],
  entryComponents: [
    ModalComponent,
  ]
})
export class SharedModule {
}
